import { SearchInput } from "@cafegestor/ui";
import { Alert, Badge, Button, Select } from "@/components/ui";
import { errorMessage } from "@/lib/api";
import type { ReactNode } from "react";
import type { StatusFilter } from "./lib";

// pesquisa e caixa de seleção agora vêm do pacote de interface compartilhado (A0)
export { Checkbox, SearchInput } from "@cafegestor/ui";

export function ListToolbar({
  q,
  onQ,
  status,
  onStatus,
  placeholder = "Buscar por código ou nome",
  children,
}: {
  q: string;
  onQ: (v: string) => void;
  status: StatusFilter;
  onStatus: (v: StatusFilter) => void;
  placeholder?: string;
  children?: ReactNode;
}) {
  return (
    <div className="mb-4 flex flex-wrap items-center gap-3">
      <SearchInput value={q} onChange={onQ} placeholder={placeholder} label="Buscar" />
      <Select
        className="w-40"
        value={status}
        onChange={(e) => onStatus(e.target.value as StatusFilter)}
        aria-label="Situação"
      >
        <option value="active">Ativos</option>
        <option value="inactive">Inativos</option>
        <option value="all">Todos</option>
      </Select>
      {children}
    </div>
  );
}

export function Pager({
  total,
  offset,
  limit = 50,
  onOffset,
}: {
  total: number;
  offset: number;
  limit?: number;
  onOffset: (o: number) => void;
}) {
  if (total <= limit)
    return <p className="mt-4 text-sm text-muted-foreground">{total} registro(s)</p>;
  return (
    <div className="mt-4 flex flex-wrap items-center gap-3 text-sm">
      <Button
        size="sm"
        variant="secondary"
        disabled={offset === 0}
        onClick={() => onOffset(Math.max(0, offset - limit))}
      >
        Anterior
      </Button>
      <span className="text-muted-foreground">
        {offset + 1}–{Math.min(offset + limit, total)} de {total}
      </span>
      <Button
        size="sm"
        variant="secondary"
        disabled={offset + limit >= total}
        onClick={() => onOffset(offset + limit)}
      >
        Próxima
      </Button>
    </div>
  );
}

export function StatusBadge({ status }: { status: string }) {
  return status === "active" ? <Badge tone="ok">Ativo</Badge> : <Badge>Inativo</Badge>;
}

export function SaveError({ error }: { error: unknown }) {
  if (!error) return null;
  return <Alert tone="error">{errorMessage(error)}</Alert>;
}
